
//
const zenoFetch = require('../utils/zenoFetch.js');

//
const trainingCourseFilterForm = document.querySelector('.trainingCourseSearch');

//
const allTrainingSearchResults = document.querySelector('#allTrainingSearchResults');

//
if (trainingCourseFilterForm == null || allTrainingSearchResults == null) {
    return;
}

//
trainingCourseFilterForm.addEventListener('submit', async (event) => {

    //
    event.preventDefault();

    //
    const trainingCourseFilterFormData = new FormData(trainingCourseFilterForm)

    //
    let payload = {};

    //
    for (let input of trainingCourseFilterFormData.entries()) {
        payload[input[0]] = input[1];
    }

    //
    const [status, response] = await zenoFetch('post', '/api/training-search', null, payload);

    //
    let searchResults = response.searchResults

    //
    if (status == 'success') {

        //
        dayjs.locale('en');

        //
        allTrainingSearchResults.innerHTML = zeno_template('tpl-training-search-results', {searchResults});

    }

    //
    document.querySelector('input[name="trainingSearchFromDateFilter"]').value = payload.trainingSearchFromDateFilter;
    document.querySelector('input[name="trainingSearchToDateFilter"]').value = payload.trainingSearchToDateFilter;

    //
    document.querySelector('select[name="trainingSearchCPDFilter"]').setAttribute('data-selected', `${payload.trainingSearchCPDFilter}`);
    document.querySelector('select[name="trainingSearchCourseTypeFilter"]').setAttribute('data-selected', `${payload.trainingSearchCourseTypeFilter}`);

});

